import { Text } from 'src/Components'
import styles from '../SavedSearchAlertModal.module.scss'

export interface SavedSearchAlertModalHeaderProps {
  headerMsg: string
}

export const SavedSearchAlertModalHeader = ({
  headerMsg,
}: SavedSearchAlertModalHeaderProps) => (
  <Text
    variant='neutralCool'
    variantCount='900'
    weight='bold'
    element='h1'
    size='l'
    align='left'
    className={styles.detail}
  >
    {headerMsg}
  </Text>
)
